(() => {
  if (customElements.get('yb-ultra-product-film')) return;
  class YbUltraProductFilm extends HTMLElement {
    connectedCallback() {
      if (this.bound) return;
      this.video = this.querySelector('[data-ybpf-video]');
      this.playButton = this.querySelector('[data-ybpf-play]');
      this.soundButton = this.querySelector('[data-ybpf-sound]');
      this.controls = this.querySelector('[data-ybpf-controls]');
      this.error = this.querySelector('[data-ybpf-error]');
      this.progress = this.querySelector('[data-ybpf-progress]');
      if (!this.video || !this.playButton || !this.soundButton || !this.controls || !this.error || !this.progress) return;
      this.bound = true;
      this.abort = new AbortController();
      this.video.muted = true;
      this.video.autoplay = false;
      this.video.loop = false;
      const on = (target,type,handler) => target?.addEventListener(type,handler,{signal:this.abort.signal});
      on(this.playButton,'click',() => {
        if (!this.video.paused) {
          this.video.pause();
        } else {
          this.play();
        }
      });
      on(this.soundButton,'click',() => { this.video.muted = !this.video.muted; });
      on(this.video,'volumechange',() => this.updateSound());
      on(this.video,'playing',() => {
        this.setAttribute('data-playing','');
        this.playButton.setAttribute('aria-label',this.dataset.labelPause);
        this.playButton.title = this.dataset.labelPause;
        this.error.hidden = true;
      });
      on(this.video,'pause',() => this.updatePause());
      on(this.video,'ended',() => { this.updatePause(); this.updateProgress(); });
      on(this.video,'timeupdate',() => this.updateProgress());
      on(this.video,'loadedmetadata',() => this.updateProgress());
      on(this.video,'error',() => this.fail());
      on(document,'visibilitychange',() => {
        if (document.hidden) this.video.pause();
      });
      this.video.controls = false;
      this.video.removeAttribute('src');
      this.video.load();
      this.controls.hidden = false;
      this.setAttribute('data-enhanced','');
      this.updatePause();
      this.updateSound();
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(entries => {
          const inView = entries[0].isIntersecting && entries[0].intersectionRatio >= 0.2;
          if (!inView) this.video.pause();
        },{threshold:[0,0.2]});
        this.observer.observe(this.querySelector('[data-ybpf-frame]'));
      }
    }
    updatePause() {
      this.removeAttribute('data-playing');
      this.playButton.setAttribute('aria-label',this.dataset.labelPlay);
      this.playButton.title = this.dataset.labelPlay;
    }
    updateSound() {
      this.toggleAttribute('data-sound-on',!this.video.muted);
      const label = this.video.muted ? this.dataset.labelUnmute : this.dataset.labelMute;
      this.soundButton.setAttribute('aria-label',label);
      this.soundButton.title = label;
    }
    updateProgress() {
      const fraction = this.video.duration > 0 ? Math.max(0,Math.min(1,this.video.currentTime / this.video.duration)) : 0;
      this.progress.style.setProperty('--ybpf-progress',String(fraction));
    }
    async play() {
      if (document.hidden) return;
      if (!this.video.getAttribute('src')) {
        let source;
        if (!this.dataset.source?.trim()) { this.fail(); return; }
        try { source = new URL(this.dataset.source,location.href); } catch { this.fail(); return; }
        if (source.protocol !== 'https:') { this.fail(); return; }
        this.video.src = source.href;
      }
      try { await this.video.play(); }
      catch { this.updatePause(); if (this.video.error) this.fail(); }
    }
    fail() {
      this.video.pause();
      this.video.removeAttribute('src');
      this.video.load();
      this.updatePause();
      this.progress.style.setProperty('--ybpf-progress','0');
      this.error.hidden = false;
    }
    disconnectedCallback() {
      if (!this.bound) return;
      this.observer?.disconnect();
      this.abort?.abort();
      this.video.pause();
      this.video.removeAttribute('src');
      this.video.load();
      this.controls.hidden = true;
      this.video.controls = true;
      this.removeAttribute('data-enhanced');
      this.bound = false;
    }
  }
  customElements.define('yb-ultra-product-film',YbUltraProductFilm);
})();
